var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.categories !== null && _vm.categories.length > 0
    ? _c(
        "div",
        { staticClass: "additional-products-content" },
        [
          _c("p", { staticClass: "header summary" }, [
            _vm._v("Opcje dodatkowe")
          ]),
          _vm._v(" "),
          _vm._l(_vm.categories, function(category) {
            return _c("div", { staticClass: "categories-list" }, [
              _c(
                "div",
                { staticClass: "tab-header-warp" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "tab-header",
                      on: {
                        click: function($event) {
                          return _vm.toggleItem(category.id)
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: category.image,
                          alt: category.name,
                          width: "40",
                          height: "40"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "title" }, [
                        _c("strong", [_vm._v(_vm._s(category.name))]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n                  " +
                            _vm._s(category.description) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "arrow-button",
                        class: { open: category.id === _vm.selectedCategory }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.products !== null && _vm.products.length > 0
                    ? _vm._l(_vm.products, function(product) {
                        return product.categoryId == category.id
                          ? _c(
                              "div",
                              {
                                staticClass: "content",
                                class: {
                                  open: category.id === _vm.selectedCategory
                                }
                              },
                              [
                                _c("div", { staticClass: "add-image" }, [
                                  _c("img", {
                                    attrs: {
                                      src: product.image,
                                      width: "80",
                                      height: "80",
                                      alt: "Zobacz produkt"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.showProduct(product)
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "add-name" }, [
                                  _c(
                                    "div",
                                    { staticClass: "product-name-short" },
                                    [_vm._v(_vm._s(product.name))]
                                  ),
                                  _vm._v(
                                    "\n                " + _vm._s(product.price)
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showProduct(product)
                                        }
                                      }
                                    },
                                    [_vm._v("Zobacz produkt")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "add-button" }, [
                                  _vm.symbolOpen !== product.symbol &&
                                  product.isPersonalized
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "button button-personalize-small",
                                          attrs: {
                                            type: "button",
                                            name: "personalizuj",
                                            value: "Personalizuj",
                                            title: "Personalizuj"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.personalizeProduct(
                                                product
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "button-title" },
                                            [_vm._v("Personalizuj")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.symbolOpen !== product.symbol &&
                                  !product.isPersonalized
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "button button-personalize-small",
                                          attrs: {
                                            type: "button",
                                            name: "personalizuj",
                                            value: "Do koszyka",
                                            title: "Dodaj do koszyka"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.addProductToCart(
                                                product
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "button-title" },
                                            [_vm._v("Do koszyka")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.symbolOpen === product.symbol
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "button button-personalize-selected-small",
                                          attrs: {
                                            type: "button",
                                            name: "personalizuj",
                                            value: "Personalizuj",
                                            title: "Powrót do edycji"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.backToEdit()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "button-title" },
                                            [_vm._v("Powrót do edycji")]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          : _vm._e()
                      })
                    : _vm._e()
                ],
                2
              )
            ])
          }),
          _vm._v(" "),
          _c(
            "sidebar-modal",
            {
              class: { visible: _vm.showSidebarModal },
              on: {
                close: function($event) {
                  return _vm.toggleSidebarModal(false)
                }
              }
            },
            [
              _vm.product !== null
                ? _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("div", { staticClass: "modal-name" }, [
                      _vm._v(_vm._s(_vm.product.name))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-association-symbol small" },
                      [_vm._v(_vm._s(_vm.product.symbol))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "modal-url small",
                        attrs: { href: _vm.product.url }
                      },
                      [_vm._v("Przejdź do produktu")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.product !== null
                ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                    _c("div", { staticClass: "swiper-container" }, [
                      _c("ul", { staticClass: "swiper-wrapper" }, [
                        _c("li", { staticClass: "swiper-slide" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.product.image,
                              width: "280",
                              height: "280",
                              alt: "Zdjęcie"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "swiper-slide" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.product.image2,
                              width: "280",
                              height: "280",
                              alt: "Zdjęcie"
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("br", { attrs: { clear: "all" } })
                    ]),
                    _c("div", { staticClass: "tab-header" }, [
                      _vm._v("Szczegóły produktu")
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "message",
                      domProps: {
                        innerHTML: _vm._s(_vm.product.technicalDescription)
                      }
                    })
                  ])
                : _vm._e()
            ]
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }